"use client"

import { useMutation } from "@tanstack/react-query"
import {
  importKnowledgeBaseFromUrlAction,
  type ImportKnowledgeBaseFromUrlInput,
  type ImportKnowledgeBaseFromUrlResult,
} from "@/server-actions/knowledge-base-url-import"
import { useTranslatedQueryHandling } from "@/hooks/use-translated-query-handling"

import { useTranslations } from "next-intl"


export type ImportKnowledgeBaseFromUrlMutationInput = ImportKnowledgeBaseFromUrlInput & {
  setErrors?: (errors: Record<string, unknown>) => void
}

export function useImportKnowledgeBaseFromUrlMutation(options?: {
  onSuccess?: (result: ImportKnowledgeBaseFromUrlResult) => void | Promise<void>
}) {
  const withQueryHandling = useTranslatedQueryHandling()

  const tUi = useTranslations("Feedback.MutationsKnowledgeBaseUrlImport")

  return useMutation({
    mutationFn: async ({ setErrors, ...input }: ImportKnowledgeBaseFromUrlMutationInput): Promise<ImportKnowledgeBaseFromUrlResult> => {
      const result = await withQueryHandling(importKnowledgeBaseFromUrlAction(input), {
        loading: tUi("startingWebsiteImport"),
        success: tUi("websiteImportStarted"),
        setErrors,
      })

      return result as ImportKnowledgeBaseFromUrlResult
    },
    onSuccess: options?.onSuccess,
  })
}
